import React from "react";

/**
 * Small pill/badge chip component.
 */
export const Chip = ({ children, className = "", style = {}, ...rest }) => (
  <span
    className={`smChip Content-Small ${className}`.trim()}
    style={style}
    {...rest}
  >
    {children}
  </span>
);

/**
 * Card section with an optional title and children.
 */
export const PostCard = ({ title, children }) => (
  <div className="smPost">
    {title ? (
      <div className="smPostHeader">
        <h4 className="smPostTitle Content-SemiBold">{title}</h4>
      </div>
    ) : null}
    <div className="smPostBody">{children}</div>
  </div>
);

/**
 * Label / value row, with optional link href.
 * kind: "date" | "monthYear" | undefined (plain text)
 */
export const Row = ({ label, value, href, kind }) => {
  const display =
    value === null || value === undefined || value === "" ? "-" : String(value);

  const content =
    href && display !== "-" ? (
      <a
        className="Content Content-Small"
        href={href}
        target={href.startsWith("http") ? "_blank" : undefined}
        rel="noopener noreferrer"
      >
        {display}
      </a>
    ) : (
      <span className="Content Content-Small">{display}</span>
    );

  return (
    <div className="smRow">
      <span className="smRowLabel Content-Small muted">{label}</span>
      <div className="smRowValue">{content}</div>
    </div>
  );
};
